export const TAB_REPORTS_NUMBER = '1';
export const TAB_NOTES_NUMBER = '2';
export const TAB_RATED_AGE_NUMBER = '3';
export const TAB_FILES_NUMBER = '4';
export const TAB_COMMENTS_NUMBER = '5';
export const TAB_CHAT_NUMBER = '6';
export const TAB_INVOICING_NUMBER = '7';
export const TAB_NOTIFICATION_NUMBER = '8';